import { Box, Flex, HStack, Stack, VStack } from "@chakra-ui/layout";
import { useEffect, useState } from "react";
import { LoggedInLayout } from "../components/layouts/LoggedInLayout";
import LoadingIndicator from "../components/Loading";
import { useCustomerUsersCustomers } from "@api/hooks";
import { Popover, PopoverBody, PopoverContent, PopoverTrigger, Checkbox, CheckboxGroup, Text } from "@chakra-ui/react";
import DropDownIcon from "../components/icons/DropDownIcon";
import JobView from "../components/scheduleView/JobView";
import ConsultantView from "../components/scheduleView/ConsultantView";
import { MonthSelectorState } from "@models/Schedule";

const SchedulePage = () => {
	const { customers, isLoading } = useCustomerUsersCustomers();
	const [selectedUnits, setSelectedUnits] = useState<string[]>(customers?.customers?.map((c) => c.id) ?? []);
	const [isJobView, setIsJobView] = useState<boolean>(true);
	const [dateValues, setDateValues] = useState<MonthSelectorState>(() => {
		const currentDate = new Date();
		const startDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
		const endDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
		return { startDate, endDate };
	});

	useEffect(() => {
		setSelectedUnits(customers?.customers?.map((c) => c.id) ?? []);
	}, [JSON.stringify(customers?.customers?.map((c) => c.id))]);

	return (
		<LoggedInLayout width="full" bg={"#edeff3"}>
			<VStack spacing={"1.5rem"} align={"flex-start"} w="full">
				<Text fontWeight={600} fontSize={24} mt={2} mb={0}>
					Schema
				</Text>
				{isLoading && <LoadingIndicator size={"s"} />}
				{!isLoading && (
					<HStack>
						<Popover placement="bottom-start">
							<PopoverTrigger>
								<Flex
									height={"44px"}
									width={"280px"}
									borderColor={"#B5B4B2"}
									borderWidth={1}
									borderRadius={14}
									_hover={{ cursor: "pointer" }}
									direction={"row"}
									alignItems={"center"}
									justify={"space-between"}
									backgroundColor={"#FFFFFF"}
									p={2}
								>
									<Text m={0} fontSize="16px" fontWeight={400}>
										Filtrera på enhet
									</Text>
									<DropDownIcon />
								</Flex>
							</PopoverTrigger>
							<PopoverContent>
								<PopoverBody>
									<CheckboxGroup
										colorScheme="blue"
										value={selectedUnits}
										onChange={(value) => {
											setSelectedUnits(value as string[]);
										}}
									>
										<Stack spacing={2} direction={"column"}>
											{customers?.customers?.map((item) => (
												<Checkbox key={item.id} value={item.id}>
													{item.name ?? ""}
												</Checkbox>
											))}
										</Stack>
									</CheckboxGroup>
								</PopoverBody>
							</PopoverContent>
						</Popover>

						<Flex
							height={"44px"}
							borderRadius={15}
							_hover={{ cursor: "pointer" }}
							direction={"row"}
							alignItems={"center"}
							justify={"space-between"}
							backgroundColor={"#FFFFFF"}
							p={2}
							onClick={() => setIsJobView((prev) => !prev)}
						>
							<Box
								background={isJobView ? "#353535" : "#FFFFFF"}
								color={isJobView ? "#FFFFFF" : "#9a9a9a"}
								fontWeight={500}
								fontSize={"14px"}
								height={"34px"}
								px={3}
								borderRadius={13}
								as="button"
							>
								Uppdrag
							</Box>
							<Box
								background={isJobView ? "#FFFFFF" : "#353535"}
								color={isJobView ? "#9a9a9a" : "#FFFFFF"}
								fontWeight={500}
								fontSize={"14px"}
								height={"34px"}
								borderRadius={13}
								as="button"
								px={3}
							>
								Konsulter
							</Box>
						</Flex>
					</HStack>
				)}

				{!isLoading && isJobView && (
					<JobView setDateValues={setDateValues} dateValues={dateValues} selectedUnits={selectedUnits} />
				)}
				{!isLoading && !isJobView && (
					<ConsultantView setDateValues={setDateValues} dateValues={dateValues} selectedUnits={selectedUnits} />
				)}
			</VStack>
		</LoggedInLayout>
	);
};

export default SchedulePage;
